import { Component, ElementRef, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { ProcessListService } from 'src/services/process-list.service';
import { CustomValidators } from 'src/validators';
import { Observable, Subject } from 'rxjs';
import * as STATES from 'src/assets/states.json';
import { ViaCepService } from 'src/services/via-cep.service';
import { debounceTime, map } from 'rxjs/operators';
import * as accents from 'remove-accents';
import * as moment from 'moment';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import * as SINONIMO from 'src/assets/sinonimo.json';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { TokenService } from 'src/services/token.service';

@Component({
  selector: 'app-process-list-name-dialog',
  templateUrl: './process-list-name-dialog.component.html',
  styleUrls: ['./process-list-name-dialog.component.scss']
})
export class ProcessListNameDialogComponent implements OnInit {

  form: FormGroup;
  states: Array<any> = (STATES as any).default;
  cities: Array<any> = [];
  filteredStates$: Observable<any>;
  filteredCities$: Observable<any>;
  sinonimos: Array<any> = (SINONIMO as any).default;
  allSinonimo
  filteredSinonimo
  isEditing: boolean = false;
  idProcess: number;
  @ViewChild('zipCodeInput') zipCodeInput: ElementRef;
  submiting: boolean = false;
  formChanged: boolean = false;
  formFocused: boolean = false;
  useIA: boolean;

  constructor(
    private processList: ProcessListService,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) data: any,
    private http: HttpService,
    private errorReport: ErrorReportService,
    private snackbar: MatSnackBar,
    private router: Router,
    private location: Location,
    private viaCep: ViaCepService,
    private dialogRef: MatDialogRef<ProcessListNameDialogComponent>,
    private elRef: ElementRef,
    private renderer: Renderer2,
    private token: TokenService
  ) {

    this.allSinonimo = this.sinonimos;

    this.form = fb.group({
      name: [null, Validators.required],
      qtd: [null, [Validators.required, Validators.pattern('[0-9]*'), Validators.min(1), Validators.max(1000)]],
      phone: [null, [Validators.required, CustomValidators.phone]],
      companyname: [null],
      viewname: [null],
      viewend: [null],
      viewtel: [null],
      zipCode: [null],
      state: [null],
      stateName: [null],
      city: [null],
      district: [null],
      street: [null],
      number: [null],
      complement: [null],
      modalityjob: [null, Validators.required],
      sinonimo: [null, Validators.required],
      salary: [null],
      coin: ['BRL', Validators.required],
      workregime: [null, Validators.required],
      daysWeek: [['monday', 'tuesday', 'wednesday', 'thursday', 'friday']],
      start_monday: [null, Validators.required],
      end_monday: [null, Validators.required],
      start_tuesday: [null],
      end_tuesday: [null],
      start_wednesday: [null],
      end_wednesday: [null],
      start_thursday: [null],
      end_thursday: [null],
      start_friday: [null],
      end_friday: [null],
      start_saturday: [null],
      end_saturday: [null],
      start_sunday: [null],
      end_sunday: [null],
      benefits: [null, Validators.required],
      description: [null, Validators.required],
      requirements: [null, Validators.required],
      activities: [null, Validators.required],
      tipocargo: ["junior", Validators.required]
    })

    if (data && data.processList && data.processList.name) {

      this.idProcess = data.processList.id;
      data.processList.daysWeek = this.transformDaysWeek(data.processList.daysWeek);
      data.processList.viewname = data.processList.viewname === 'true';
      data.processList.viewend = data.processList.viewend === 'true';
      data.processList.viewtel = data.processList.viewtel === 'true';
      data.processList.salary = (data.processList.salary === '0000') ? 'à combinar' : this.formatSalaryForEdit(data.processList.salary);

      if (data.processList.viewname === true) {
        this.form.get('companyname').setValidators([Validators.required]);
      } else {
        this.form.get('companyname').clearValidators();
      }

      this.form.get('companyname').updateValueAndValidity();

      if (data.processList.viewend === true) {
        this.form.get('zipCode').setValidators([Validators.required, CustomValidators.cep]);
        this.form.get('state').setValidators([Validators.required]);
        this.form.get('city').setValidators([Validators.required]);
        this.form.get('district').setValidators([Validators.required]);
        this.form.get('street').setValidators([Validators.required]);
        this.form.get('number').setValidators([Validators.required]);
      } else {
        this.form.get('zipCode').clearValidators();
        this.form.get('state').clearValidators();
        this.form.get('city').clearValidators();
        this.form.get('district').clearValidators();
        this.form.get('street').clearValidators();
        this.form.get('number').clearValidators();
      }

      this.form.get('zipCode').updateValueAndValidity();
      this.form.get('state').updateValueAndValidity();
      this.form.get('city').updateValueAndValidity();
      this.form.get('district').updateValueAndValidity();
      this.form.get('street').updateValueAndValidity();
      this.form.get('number').updateValueAndValidity();

      if (data.processList.viewtel === true) {
        this.form.get('phone').setValidators([Validators.required, CustomValidators.phone]);
      } else {
        this.form.get('phone').clearValidators();
      }

      this.form.get('phone').updateValueAndValidity();


      this.form.patchValue(data.processList);

      // Inicialize os campos de horários aqui, após patchValue
      this.initializeTimeControls(data.processList.daysWeek);

      const daysWeekArray = this.form.get('daysWeek').value || [];

      for (const dia of daysWeekArray) {
        const startControlName = 'start_' + dia;
        const endControlName = 'end_' + dia;

        this.form.get(startControlName)?.patchValue(data.processList[startControlName]);
        this.form.get(endControlName)?.patchValue(data.processList[endControlName]);
      }

      this.isEditing = true;

    } else {
      const user = JSON.parse(localStorage.getItem('token'));
      
      this.http.get('company', { id: user.company_id })
        .subscribe(
          (result: any) => {
            if (result.type === 'OK') {
              //console.log('resultado', result);
              this.form.patchValue({ 
                companyname: result.data.companyname,
                phone: result.data.companyphone
               });
            }
          },
          err => this.errorReport.showMessage(err)
        );
    }

  }

  preventNonNumeric(event: KeyboardEvent) {
    const pattern = /[0-9]/;
    if (!pattern.test(event.key)) {
      event.preventDefault();
    }
    const inputValue = (event.target as HTMLInputElement).value;
    const newValue = inputValue + event.key;
    if (parseInt(newValue, 10) > 1000) {
      event.preventDefault();
    }
  }

  ngOnInit(): void {
    this.token.atualizar();
    setTimeout(()=>{
      const user = JSON.parse(localStorage.getItem('token'));
      this.useIA = !!user.use_ia;
    },250);
    
    this.processList.clear(this.idProcess);

    this.renderer.listen('window', 'focusin', () => this.verifyFormFocused());
    this.renderer.listen('window', 'focusout', () => this.verifyFormFocused());
    
    const subject = new Subject<any>();
    subject.subscribe(({ trigger }: any) => {
      this.submiting = trigger == "pre" && this.formFocused == false;
      
      if (this.submiting) this.form.disable({ emitEvent: false });
      else this.form.enable({ emitEvent: false });
    });

    this.form.get('viewname').valueChanges.subscribe(value => {
      if (value === true) {
        this.form.get('companyname').setValidators([Validators.required]);
      } else {
        this.form.get('companyname').clearValidators();
      }
      this.form.get('companyname').updateValueAndValidity();
    });

    this.form.get('viewend').valueChanges.subscribe(value => {
      // console.log('mudou', value);
      if (value === true) {
        this.form.get('zipCode').setValidators([Validators.required, CustomValidators.cep]);
        this.form.get('state').setValidators([Validators.required]);
        this.form.get('city').setValidators([Validators.required]);
        this.form.get('district').setValidators([Validators.required]);
        this.form.get('street').setValidators([Validators.required]);
        this.form.get('number').setValidators([Validators.required]);

        setTimeout(() => {
          const zipCodeElement = document.getElementById('zipCode') as HTMLInputElement;
          if (zipCodeElement) {
            zipCodeElement.focus();
          }
        }, 0);

      } else {
        this.form.get('zipCode').clearValidators();
        this.form.get('state').clearValidators();
        this.form.get('city').clearValidators();
        this.form.get('district').clearValidators();
        this.form.get('street').clearValidators();
        this.form.get('number').clearValidators();
      }
      this.form.get('zipCode').updateValueAndValidity();
      this.form.get('state').updateValueAndValidity();
      this.form.get('city').updateValueAndValidity();
      this.form.get('district').updateValueAndValidity();
      this.form.get('street').updateValueAndValidity();
      this.form.get('number').updateValueAndValidity();
    });

    this.form.get('zipCode')
      .valueChanges
      .pipe(debounceTime(500))
      .subscribe(
        cep => {
          if (!this.form.get('zipCode').invalid) {
            this.viaCep.getLocation(cep)
              .subscribe(
                data => {

                  if (!data.erro) {
                    const { bairro, localidade, logradouro, uf } = data;

                    const state = this.states.find(state => state
                      ? state.sigla.toLowerCase() ===
                      uf.toLowerCase() : null);

                    this.form.patchValue({
                      district: bairro,
                      city: localidade,
                      street: logradouro,
                      state: uf,
                      // state: state ? state.sigla : null,
                      stateName: state ? accents.remove(state.nome) : null,
                    })

                  } else {
                    alert('CEP inválido por favor tente novamente');
                    this.form.patchValue({
                      zipCode: ''
                    });
                  }

                }
              )
          }
        }
      )

    this.filteredStates$ = this.form.get('state')
      .valueChanges
      .pipe(
        map(state => this._filterStates(state))
      );

    this.filteredCities$ = this.form.get('city')
      .valueChanges
      .pipe(map(city => this._filterCities(city)));
  
  }

  submit() {

    // Verifica se o formulário é válido
    if (this.form.invalid) {

      // Percorre os controles do formulário para encontrar o primeiro campo inválido
      for (const controlName in this.form.controls) {
        const control = this.form.get(controlName);

        if (control && control.invalid) {
          // Rola até o campo inválido
          const element = document.getElementById(controlName);
          if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            control.markAsTouched();
          }

          // Para o loop para que apenas o primeiro campo inválido seja destacado
          break;
        }
      }
      // Retorna para evitar o envio do formulário
      return;
    }

    const isValid = !this.form.invalid;
    const data = this.form.getRawValue();

    if (isValid) {

      const user = JSON.parse(localStorage.getItem('token'));
      data['company'] = user.company_id;
      data['created_by'] = user.id;
      data['daysWeek'] = Array.isArray(data.daysWeek) ? data.daysWeek.join(', ') : data.daysWeek;

      this.http.save('process_list', data)
        .subscribe(
          (result: any) => {
            this.dialogRef.close(result.data)
          },
          err => this.errorReport.showMessage(err)
        )

    }

  }

  updateProcess() {
    const isValid = !this.form.invalid;
    const data = this.form.getRawValue();
    if (isValid) {
      const user = JSON.parse(localStorage.getItem('token'));
      data['id'] = this.idProcess;
      data['company'] = user.company_id;
      data['daysWeek'] = Array.isArray(data.daysWeek) ? data.daysWeek.join(', ') : data.daysWeek;

      if(data['salary'] == 'à combinar'){
        data['salary'] = 0;
      }

      this.http.save('process_list:update', data)
        .subscribe(
          (result: any) => {
            if (result.type === 'OK') {
              this.snackbar.open('Atualizado com Sucesso', 'OK', { duration: 2000 });
              this.dialogRef.close(result.data);
            } else {
              this.snackbar.open('Não foi possível concluir a atualização. Verifique se os dados foram alterados ou tente novamente mais tarde.', 'OK', { duration: 3000 });
            }
          },
          err => this.errorReport.showMessage(err)
        )

    }

  }

  public displayState(state: any): string {
    if (state && typeof state === 'string')
      return state;

    return state ? state.sigla : null
  }

  public onStateSelected(args: MatAutocompleteSelectedEvent) {

    const { option: { value } } = args;

    this.form.get('stateName').setValue(accents.remove(value.nome));
    this.http.list('locality:city', { initials: value.sigla })
      .subscribe(
        (cities: any) => {
          this.cities = cities;
        }
      );

  }

  private _filterCities(city) {

    if (!city) {
      return [];
    }

    city = city.toLowerCase();
    return this.cities.filter(_city => _city.name.toLowerCase().indexOf(city) > -1);

  }

  private _filterStates(state) {

    if (typeof state !== 'string') return;

    let name = accents.remove(state.toLowerCase());
    return this.states.filter(_state => accents.remove(_state.nome).toLowerCase().indexOf(name) > -1
      || _state.sigla.toLowerCase().indexOf(name) > -1);

  }

  public _filterSinonimo(Sinonimo) {
    if (Sinonimo === null) return;
    //Filtra apenas quando tiver mais que 3 caracteres
    if (Sinonimo.length >= 3) {
      Sinonimo = accents.remove(Sinonimo).toLowerCase().trim();
      this.filteredSinonimo = this.allSinonimo.filter(_sinonimo => accents.remove(_sinonimo.Name).toLowerCase().indexOf(Sinonimo) > -1);
    } else {
      return;
    }
  }

  onBlurInput(name: string): void {

    setTimeout(() => {

      const control = this.form.get(name);
      let invalid = false;
      switch (name) {
        case 'sinonimo': invalid = this.allSinonimo.findIndex(_sinonimo => _sinonimo.Name === control.value) === -1; break;
      }

      if (invalid) {
        control.setValue(null);
        control.setErrors({
          invalid: true
        })
      }

    }, 500)

  }

  onFocusInput(inputName: string) {

    const inputControl = this.form.get(inputName);
    const pristine = inputControl.pristine;

    if (pristine)
      inputControl.setValue(' ');

  }

  getDiaSemana(dia: string): string {
    const diasSemana = {
      'monday': 'segunda-feira',
      'tuesday': 'terça-feira',
      'wednesday': 'quarta-feira',
      'thursday': 'quinta-feira',
      'friday': 'sexta-feira',
      'saturday': 'sábado',
      'sunday': 'domingo'
    };

    return diasSemana[dia.toLowerCase()];
  }

  formatarHora(hora: string): string {
    if (!hora) {
      return '';
    }
    const [horas, minutos] = hora.split(':');
    return `${horas.padStart(2, '0')}:${minutos.padStart(2, '0')}`;
  }

  initializeTimeControls(days: string[]): void {
    days.forEach(day => {
      if (!this.form.contains('start_' + day)) {
        this.form.addControl('start_' + day, new FormControl(null));
      }
      if (!this.form.contains('end_' + day)) {
        this.form.addControl('end_' + day, new FormControl(null));
      }
    });
  }

  transformDaysWeek(daysWeek: any): string[] {
    if (Array.isArray(daysWeek)) {
      return daysWeek; // It's already an array, return as is.
    } else if (typeof daysWeek === 'string') {
      return daysWeek.split(',').map(day => day.trim()); // Split string by commas and trim spaces.
    }
    return []; // If daysWeek is neither an array nor a string, return an empty array.
  }

  formatMoneyInput(event: any): void {
    let value = event.target.value;

    // Remover qualquer formatação existente
    value = value.replace(/\D/g, '');

    // Adicionar vírgula após o terceiro caractere
    if (value.length > 3) {
      const beforeDecimal = value.slice(0, -2);
      const afterDecimal = value.slice(-2);
      value = beforeDecimal + ',' + afterDecimal;
    }

    // Formatar o valor inserindo o ponto como separador de milhares
    value = value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    // Atualizar o valor no campo de entrada
    event.target.value = value;
  }

  formatSalaryForEdit(salary: string): string {
    if (!salary) {
      return '';
    }

    // Remover formatação existente
    const cleanValue = salary.replace(/[^\d,]/g, '');

    // Remover vírgula
    const noCommaValue = cleanValue.replace(',', '');

    let formattedValue = '';

    // Verificar se o valor tem mais de 3 dígitos para adicionar separadores
    if (noCommaValue.length > 3) {
      const integerPart = noCommaValue.slice(0, -2); // Parte inteira sem os dois últimos dígitos
      const decimalPart = noCommaValue.slice(-2); // Últimos dois dígitos como parte decimal
      formattedValue = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + decimalPart;
    } else {
      formattedValue = noCommaValue + ',00'; // Se tiver menos de 3 dígitos, adicionar ',00' para decimal
    }

    return formattedValue;
  }

  resetValue(){

    this.form.patchValue({ 
      tipocargo: null
    });

  }
 
  generateAI(type: string) {
    const data = this.form.getRawValue();
    const form = this.fb.group({
      name: [data.name, Validators.required],
      qtd: [data.qtd, Validators.required],
      phone: [data.phone],
      showCompanyName: [data.viewname],
      jobLevel: [data.tipocargo, Validators.required],
      companyname: [data.companyname, Validators.required],
      modalityjob: [data.modalityjob, Validators.required],
      sinonimo: [data.sinonimo, Validators.required],
      workregime: [data.workregime, Validators.required],
      weekdays: [data.daysWeek, Validators.required],
      startMonday: [data.start_monday, Validators.required],
      endMonday: [data.end_monday, Validators.required],
    });

    if (form.valid) {
      this.form.disable({ emitEvent: false });

      const mapActions: any = {
        description: "ai-generator:description",
        requirements: "ai-generator:requirements",
        activities: "ai-generator:activities",
        benefits: "ai-generator:benefits",
      };

      this.http.save(mapActions[type], form.getRawValue()).subscribe({
        next: (result: any) => {
          if (result.data.text)
            this.form.get(type).setValue(result.data.text, { emit: false });
        },
        error: (err: any) => this.errorReport.showMessage(err),
        complete: () => {
          // 🔓 Reabilita o formulário depois da resposta
          this.form.enable({ emitEvent: false });
        }
      });
    }else {
      // ⚠️ Marca os campos como "tocados" para exibir erros no HTML
      form.markAllAsTouched();
  
      // 🔁 Atualiza as validações caso algo esteja pendente
      form.updateValueAndValidity();
  
      this.snackbar.open('Por favor, verifique se todos os campos obrigatórios foram preenchidos antes de gerar com IA', 'OK', { duration: 2000 });
    } 
  }

  private verifyFormFocused() {

    const isFocused = this.elRef.nativeElement.contains(document.activeElement);    
    this.formFocused = isFocused;

  }

}
